var DevOps = "DevOps";
var Gaming = "Videogiochi";
var Migration = "Migrazione";
var Other = "Altro";
var useCase = {
	"Use case": "Caso d'uso",
	"AI & machine learning": "Intelligenza artificiale (IA) e machine learning",
	"Batch processing": "Elaborazione batch",
	"Big data, analytics, & business intelligence": "Big Data, Analytics e Business Intelligence",
	"Business applications - Microsoft": "Applicazioni business - Microsoft",
	"Business applications - Oracle": "Applicazioni business - Oracle",
	"Business applications - Other": "Applicazioni business - Altro",
	"Business applications - SAP": "Applicazioni business - SAP",
	"Content delivery": "Distribuzione di contenuti",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "Internet of Things",
	"Learning & certification": "Apprendimento e certificazioni",
	"Media services": "Servizi multimediali",
	Migration: Migration,
	"Mobile applications": "Applicazioni mobile",
	Other: Other,
	"Storage & backup": "Archiviazione e backup",
	"Websites & web apps": "Siti Web e applicazioni Web"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
